import analysisModule from "./analysisModule"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"
import server from "../server"
import tdnSpecification from "../r2/tdnSpecification.json"

analysisModule.controller("analysisController", [
    "$scope",
    "nodeIdentifiers",
    "nodeCommandViewRoute",
    "nodeCommandOptimize",
    "nodeCommandOptimizeRestrictions",
    "nodeCommandInvoiceView",
    "analysisService",
    "loadingService",
    "messagesModal",
    "preValidationService",
    "OptimizationSource",
    "organizeService",
    "$http",
    "FlowType",
    "integrationService",
    "stopFitModal",
    "tripEditionService",
    "orderService",
    "remoteExceptionHandler",
    "$modal",
    "spreadsheetModal",
    "nodeCommandStartMonitorableConfiguration",
    "nodeCommandExportAllTripPickingList",
    "$q",
    "shadowTreeExpanderService",
    "restrictionsModal",
    "planningUserPreferencesService",
    "supplyService",
    ($scope,
     nodeIdentifiers,
     nodeCommandViewRoute,
     nodeCommandOptimize,
     nodeCommandOptimizeRestrictions,
     nodeCommandInvoiceView,
     analysisService,
     loadingService,
     messagesModal,
     preValidationService,
     OptimizationSource,
     organizeService,
     $http,
     FlowType,
     integrationService,
     stopFitModal,
     tripEditionService,
     orderService,
     remoteExceptionHandler,
     $modal,
     spreadsheetModal,
     nodeCommandStartMonitorableConfiguration,
     nodeCommandExportAllTripPickingList,
     $q,
     shadowTreeExpanderService,
     restrictionsModal,
     planningUserPreferencesService, supplyService) => {


        const entityType = "trip"

        let baskets = {
            orders: null,
            trips: null
        }

        //Será populado na diretiva de seleção de tipos
        $scope.viewType = {}

        $scope.baskets = baskets
        $scope.routingConfigId = null
        $scope.tdn = tdnSpecification["analysis"]

        $scope.selection = {
            deliveryUnits: {},
            tripBasket: {}
        }

        $scope.refilterBaskets = () => {
            return $q.all([
                    baskets.orders.refreshFilter(),
                    baskets.trips.refreshFilter()
                ]
            )
        }

        $scope.shadowTreeExpander = shadowTreeExpanderService.getExpanderByType("ANALYSIS_TREE")

        $scope.registerBasketApi = function (basketApiName, api) {
            baskets[basketApiName] = api
        }

        $scope.viewRoute = () => {
            nodeCommandViewRoute($scope.getSelectedTrips(), {refilter: baskets.trips.refreshFilter})
        }

        $scope.optimize = () => {
            doOptimize($scope.getSelectedTrips(), getSelectedDeliveryUnits())
        }

        $scope.optimizeWithRestrictions = () => {
            doOptimizeWithRestrictions($scope.getSelectedTrips(), getSelectedDeliveryUnits())
        }

        $scope.optimizeAllPagesWithRestrictions = () => {
            var patches = baskets.orders.getLastAppliedFilterPatches()
            loadingService($http.post(server.getServiceUrl("orderBasketUrl"), patches))
                .then(function (responseBasket) {
                    doOptimizeWithRestrictions([], responseBasket.data.result)
                })
        }

        function doOptimizeWithRestrictions(tripsToOptimize, dusToOptimize) {

            let tripsId = tripsToOptimize.map(trip => trip.id)
            let dusId = dusToOptimize.map(du => du.id)

            loadingService(
                $q.all([
                    $http.get(server.getServiceUrl("vehicleFindAll")),
                    $http.post(server.getServiceUrl("getOriginsToOptimizeWithRestrictions"),
                        {
                            "tripsId": tripsId,
                            "ordersId": dusId
                        }
                    )])
            ).then(function (response) {
                return restrictionsModal(response[0].data, response[1].data).then(restrictions => doOptimize(tripsToOptimize, dusToOptimize, restrictions))
            })
        }

        function doOptimize(tripsToOptimize, dusToOptimize, restrictions) {
            return preValidationService.getViolationsForOptimization(OptimizationSource.OPTIMIZATION, tripsToOptimize, dusToOptimize, false, FlowType.ANALYSIS)
                .then(function (result) {
                    var tripsNodeIdentifiers = tripsToOptimize.filter(function (tripIdentifier) {
                        return arrays.contains(result.entitiesToOperate.trips, tripIdentifier.id)
                    })
                    var dusNodeIdentifiers = dusToOptimize.filter(function (duIdentifier) {
                        return arrays.contains(result.entitiesToOperate.deliveryUnits, duIdentifier.id)
                    }).concat(result.additionalDeliveryUnits || [])
                    if (restrictions) {
                        return nodeCommandOptimizeRestrictions(tripsNodeIdentifiers, dusNodeIdentifiers, result.routingConfig, restrictions)
                            .then(() => {
                                return $scope.openSuccessMessageModal({
                                    keyBundle: "programming.optimization.successful.submit"
                                })
                            })
                            .finally(() => {
                                baskets.orders.refreshFilter()
                                baskets.trips.refreshFilter()
                            })
                    }

                    return nodeCommandOptimize(tripsNodeIdentifiers, dusNodeIdentifiers, result.routingConfig)
                        .then(() => {
                            return $scope.openSuccessMessageModal({
                                keyBundle: "programming.optimization.successful.submit"
                            })
                        })
                        .finally(() => {
                            baskets.orders.refreshFilter()
                            baskets.trips.refreshFilter()
                        })
                })
        }

        $scope.canOptimizeAllPages = function () {
            return isBasketNonEmpty(baskets.orders)
        }


        $scope.optimizeAllPages = function () {
            var patches = baskets.orders.getLastAppliedFilterPatches()
            $http.post(server.getServiceUrl("orderBasketUrl"), patches)
                .then(function (response) {
                    doOptimize([], response.data.result)
                })
        }
        $scope.hasSelectedDeliveryUnits = () => {
            return !!getSelectedDeliveryUnits().length
        }

        $scope.getSelectedTrips = () => {
            return nodeIdentifiers.toNodeIdentifiers($scope.selection.tripBasket.Trip || [])
        }

        $scope.getSelectedDeliveryUnitsFromAllBaskets = () => {
            var orders = (($scope.selection.tripBasket.Trip || []))
                .concat($scope.selection.deliveryUnits.DeliveryUnit || [])
            return nodeIdentifiers.toNodeIdentifiers(orders)
        }

        $scope.invoiceView = () => {
            nodeCommandInvoiceView($scope.getSelectedDeliveryUnitsFromAllBaskets())
        }

        $scope.startMonitorableView = () => {
            nodeCommandStartMonitorableConfiguration($scope.getSelectedTrips())
        }

        $scope.exportAllTripPickingList = () => {
            return nodeCommandExportAllTripPickingList($scope.getSelectedTrips())
        }

        $scope.stopFitModalOpen = () => {

            tripEditionService.getTripStatus($scope.getSelectedTrips()[0].id).then(function (status) {
                if (status !== "br.com.neolog.model.trip.TripStatus.SERVED") {
                    return messagesModal("dialog.warning", [{
                        keyBundle: "stopfit.only.served.trips.allowed",
                        parameters: []
                    }])
                }
                loadingService(
                    preValidationService.getViolationsForManualOperation(OptimizationSource.MANUAL_OPERATION, $scope.getSelectedTrips(), getSelectedDeliveryUnits(), false, FlowType.ANALYSIS).then(function (response) {
                        $scope.routingConfigId = response.routingConfig.routingConfig.id
                        loadingService($http.post(server.getServiceUrl("getFittingInformationsByTripAndOrderId") + $scope.getSelectedTrips()[0].id + "/" + getSelectedOrders()[0].id)
                            .then(function (response) {
                                orderService.getOrder(getSelectedOrders()[0].id).then(function (order) {
                                    return stopFitModal(response.data,
                                        order,
                                        $scope.routingConfigId,
                                        baskets.orders.refreshFilter,
                                        baskets.trips.refreshFilter)
                                })
                            }).catch(remoteExceptionHandler()))
                    })
                )
            })
        }

        $scope.onDropOnBasket = function (dropInfo) {
            organizeService.organize($scope.selection, dropInfo.toNode).then(function () {
                return $scope.refilterBaskets().then(function () {
                    $scope.shadowTreeExpander.addReorganizedTrip(dropInfo.toNode)
                })
            })
        }
        $scope.openSuccessMessageModal = function (message) {
            return messagesModal("dialog.success", [message])
        }

        $scope.hasSelectedTripsAndOrders = () => {
            return (getSelectedOrders().length === 1 && $scope.getSelectedTrips().length === 1)
        }

        $scope.deliveryUnitActions = [{
            name: "basketFilterSummmary.title",
            icon: "fa-ellipsis-h",
            execute: function (service, filterState) {
                var summaryUrl = server.getBaseUrl() + "/presentation/filterResultSummary"
                loadingService($http.post(summaryUrl, filterState.patch)).then(function (result) {
                    return $modal.open({
                        templateUrl: require("link!./basketFilterSummary.html"),
                        size: "lg",
                        controller: ["$scope", function ($scope) {
                            $scope.summary = result.data
                        }]
                    }).result
                })
            }
        }]

        $scope.storageFunctions = {
            savePreferences: function (preferences) {
                planningUserPreferencesService.saveAnalysisViewPreferences(preferences)
            },

            getPreferences: function () {
                return planningUserPreferencesService.getAnalysisViewPreferences()
            }
        }

        let getSelectedDeliveryUnits = () => {
            return nodeIdentifiers.toNodeIdentifiers($scope.selection.deliveryUnits.DeliveryUnit || [])
        }

        let getSelectedOrders = () => {
            return nodeIdentifiers.toNodeIdentifiers($scope.selection.deliveryUnits.Order || [])
        }

        function isBasketNonEmpty(basket) {
            if (!basket) {
                return false
            }
            var data = basket.getData()
            return data && data.children && !!data.children.length
        }

        function isAllowedAdditionalStopFit() {
            integrationService.getIntegrationConfig().then(function (result) {
                $scope.allowAdditionalStopFit = result.allowAdditionalStopFit
            })
        }

        (function () {
            isAllowedAdditionalStopFit()
        }())

        $scope.spreadsheetModal = () => {
            spreadsheetModal.show(entityType)
        }

        $scope.preventClick = (condition, callback) => {
            if (condition) {
                return callback()
            }
            return false
        }

        supplyService.registerInitialSearchWatch($scope, $scope.baskets)

    }
])